// @ts-nocheck
import { createFileRoute } from '@tanstack/react-router';
import CustomerZoneQuoteListPage from '@/PageComponents/CustomerZone/CustomerZoneQuote/CustomerZoneQuoteListPage';

export default CustomerZoneQuoteListPage;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/quotelist')({ component: CustomerZoneQuoteListPage });
